var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('AttachmentFileViewer',{ref:"fileViewer",attrs:{"hostType":_vm.hostType,"hostID":_vm.hostID,"select":false}}),_c('AttachmentFileUploader',{attrs:{"hostType":_vm.hostType,"hostID":_vm.hostID},on:{"upload":function($event){return _vm.$refs.fileViewer.initialize()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }